//changed due to package upgrade
import React, { useEffect, useState } from 'react';
import {
  Box,
  Typography,
  TextField,
  InputAdornment,
  IconButton,
} from '@mui/material';
import CompanyTheme from '@projectK/constants/CompanyTheme';
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';
import jwtAxios from '@projectK/services/auth/JWT';
import { useInfoViewActionsContext } from '@projectK/context/InfoViewContextProvider';
import AddonsCards from './AddonsCards';

const FeatureMarketplace = () => {
  const [marketPlace, setMarketPlace] = useState(null);
  const [addOns, setAddOns] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');
  const companyTheme = CompanyTheme();
  const infoViewActionsContext = useInfoViewActionsContext();

  useEffect(() => {
    fetchOrdersData();
    fetchAddonsData();
  }, []);

  const fetchOrdersData = async () => {
    try {
      const response = await jwtAxios.get(`/market-place`);
      setMarketPlace(response.data);
    } catch (error) {
      console.error('error', error);
      infoViewActionsContext.fetchError('Failed to fetch marketplace');
      setMarketPlace(null);
    }
  };

  const fetchAddonsData = async () => {
    try {
      const response = await jwtAxios.get(`/add-on`, {
        params: {
          filters: {
            is_active: 1,
          },
        },
      });
      setAddOns(response.data.list);
    } catch (error) {
      console.error('error', error);
      infoViewActionsContext.fetchError('Failed to fetch addons');
      setAddOns(null);
    }
  };

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  const handleClearSearch = () => {
    setSearchQuery('');
  };

  const filteredAddOns = addOns?.filter(
    (addon) =>
      addon.name?.toLowerCase().includes(searchQuery.toLowerCase()) ||
      addon.short_description
        ?.toLowerCase()
        .includes(searchQuery.toLowerCase()) ||
      addon.tagline?.toLowerCase().includes(searchQuery.toLowerCase()),
  );

  const headingData = marketPlace?.heading ? (
   marketPlace?.heading
  ) : (
   null
  );
let banner_url = '';
  if (marketPlace?.banner_image_url) {
    banner_url = `${process.env.NX_CLOUD_FRONT_URL}/${marketPlace?.banner_image_url}`;
  }
  return (
    <Box>
      <Box className='addons_search'>
        <div className='p-detail-bg'>
          {banner_url ? <img src={banner_url} alt='logo' width='100%' /> : null}
        </div>

        <Typography variant='h2'>{headingData}</Typography>
        <Typography variant='h3'>
          {marketPlace?.sub_heading }
        </Typography>

        <TextField
          fullWidth
          variant='outlined'
          placeholder='Search Features'
          value={searchQuery}
          onChange={handleSearchChange}
          sx={{
            maxWidth: '500px',
            borderRadius: 3,
            padding: '10px',
          }}
          slotProps={{
            input: {            startAdornment: (
              <InputAdornment position='start'>
                <SearchIcon sx={{ color: 'gray' }} />
              </InputAdornment>
            ),
            endAdornment: searchQuery && (
              <InputAdornment position='end'>
                <IconButton onClick={handleClearSearch}>
                  <CloseIcon />
                </IconButton>
              </InputAdornment>
            ),
            }
          }}
        />
      </Box>

      <Box
        sx={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: 2,
          justifyContent: 'space-between',
        }}
      >
        {filteredAddOns?.length > 0
          ? filteredAddOns.map((addOn) => (
              <AddonsCards
                key={addOn.id}
                item={addOn}
                companyTheme={companyTheme}
              />
            ))
          : 'No Add-Ons available'}
      </Box>
    </Box>
  );
};

export default FeatureMarketplace;
